import React from "react";

import { IgCardSelect } from "@intelligems/ig-theme/IgCardSelect";
import { CustomerType } from "@intelligems/ig-types/schemas/analytics/base";

interface CustomerTypeFilterProps {
  customerType: CustomerType | null;
  onCustomerTypeChange: (value: CustomerType | null) => void;
}

const customerTypeOptions: {
  title: string;
  description: string;
  value: CustomerType | null;
}[] = [
  {
    title: "All Customers",
    description: "Include orders from both new and returning customers",
    value: null,
  },
  {
    title: "New Customers",
    description:
      "Include only orders from customers making their first purchase",
    value: "new",
  },
  {
    title: "Returning Customers",
    description:
      "Include only orders from customers with a prior purchase history",
    value: "returning",
  },
];

export const CustomerTypeFilter = ({
  customerType,
  onCustomerTypeChange,
}: CustomerTypeFilterProps) => {
  return (
    <IgCardSelect
      options={customerTypeOptions}
      value={customerType}
      onChange={onCustomerTypeChange}
    />
  );
};
